/*----------------------------------
- TYPES
----------------------------------*/

export const contactLeadTopics = [
    'general',
    'api-access',
    'product-demo',
    'partnership',
    'hiring-support',
] as const;

export const contactLeadCallbackTypes = [
    'email',
    'video',
    'whatsapp',
] as const;

export type ContactLeadTopic = (typeof contactLeadTopics)[number];
export type ContactLeadCallbackType = (typeof contactLeadCallbackTypes)[number];

export type ContactLeadPayload = {
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    company?: string;
    topic: ContactLeadTopic;
    callbackType: ContactLeadCallbackType;
    message: string;
    sourcePage?: string;
};
